export const AUTH_LOGOUT_EVENT_KEY = 'auth_logout_event';

export const AUTH_TOKEN_KEY = 'auth_token';
export const AUTH_REFRESH_TOKEN_KEY = 'auth_refreshToken';
export const AUTH_USER_NAME_KEY = 'auth_userName';
export const AUTH_ROLE_KEY = 'auth_role';
export const AUTH_PUBLIC_ID_KEY = 'auth_publicId';
export const AUTH_STATUS_KEY = 'auth_status';
export const AUTH_STUDENT_PUBLIC_ID_KEY = 'auth_studentPublicId';
